/**
 * Component to Show sentReport mail
 *
 *
 *
 */

import React, { useState, useEffect, useRef, useContext } from 'react';
import ReportLink from '../report-link/report-link';
import { Form, Input, Space, Typography, Radio, message, Checkbox } from 'antd';
import { SCRFilesLink } from '../../../../models';
import { useTranslation, Button } from 'soxo-bootstrap-core';
import { MailOutlined, WhatsAppOutlined } from '@ant-design/icons';
import './send-report.scss';
const { Text } = Typography;

export default function SendReport({ props, billId, appointment_id, mail, callback, mobileNo }) {
    const [selected, setSelected] = useState({
        reports: [],
    });
    const [disable, setDisable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [form] = Form.useForm();
    const [editedEmail, setEditedEmail] = useState('');
    // const [whatsappNumber, setWhatsappNumber] = useState('');
    const [corporateEmail, setCorporateEmail] = useState('');
    const [reportKey, setReportKey] = useState(0); // used to force refresh ReportLink
    const { t, i18n } = useTranslation(); // To Translate to another language
    const [sendVia, setSendVia] = useState({
        email: true,
        corporate: false,
        whatsapp: false,
    });
    /**
     * The function `sendReportToMail` sends a report to a specified email address using an API call
     * and handles any errors that occur.
     */
    async function sendReportToMail() {
        setIsLoading(true);
        // let userData = {
        //     username: 'AUTOLOGIN2',
        //     password: 'Auto2@Log88',
        // };
        // // Fetching access token for report sending
        // const userDataDetails = await SCRFilesLink.getAccessTokenForReportSending(userData);

        const token = localStorage.access_token;
        const dbPtr = props.settings.headers.db_ptr.toString();
        // === main guest email ===
        const guestMail = props.isEmailEditable ? editedEmail || mail : mail;

        // === additional mails (default type: "new") ===
        const additionalMails = [];

        if (sendVia.corporate && corporateEmail) {
            // If corporate email is provided, add it to the additional mails
            additionalMails.push({
                email: corporateEmail,
                // default type
                type: 'new',
            });
        }
        // === Build payload ===
        let formBody = {
            mail: guestMail, // guest mail
            additional_mails: additionalMails, // always type "new"
            reports: selected,
            appointment_id: appointment_id,
        };
        /* The code is creating an object called `formBody` with three properties: `mail`, `report_id`,
       and `type`. */
        // let formBody = {
        //     mail: props.isEmailEditable ? editedEmail || mail : mail,
        //     reports: selected,
        //     appointment_id: appointment_id,
        // };

        let response = await SCRFilesLink.sendReportMail(formBody, token, dbPtr);
        if (response.success) {
            setIsLoading(false);
            message.success(response.message);
            setDisable(true);
            setReportKey((prev) => prev + 1); // trigger re-render
        } else {
            setIsLoading(false);
            message.error(response.message);
            setDisable(true);
            setReportKey((prev) => prev + 1); // trigger re-render
        }
    }
    const handleEmailCheckboxChange = (e) => {
        const newEmailChecked = e.target.checked;
        setSendVia((prev) => ({ ...prev, email: newEmailChecked }));

        // Enable only if email checkbox is checked AND at least one report is selected
        setDisable(!(selected?.length > 0 && newEmailChecked));
    };
    useEffect(() => {
        setDisable(!(selected.length > 0 && sendVia.email));
    }, [selected, sendVia.email]);
    return (
        <div className="detail-element">
            <div>
                <ReportLink
                    key={reportKey} //
                    billId={billId}
                    displayColumns={true}
                    selected={selected}
                    // callback={(values) => {
                    //     setSelected(values);
                    //     // Enable a disabled element (like a submit button)
                    //     if (values && values.length > 0) {
                    //         setDisable(false);
                    //     } else {
                    //         setDisable(true);
                    //     }
                    // }}
                    callback={(data) => {
                        if (Array.isArray(data)) {
                            setSelected(data);
                        } else if (data.selectedReports) {
                            setSelected(data.selectedReports);
                            setCorporateEmail(data.corporateEmail || ''); // <-- set corporate email here
                        }

                        // Enable/disable button
                        //  setDisable(data?.selectedReports?.length > 0);
                    }}
                />
            </div>
            <div style={{ marginTop: '10px' }} className="send-report-form">
                <Form name="emailForm" onFinish={sendReportToMail} initialValues={{ email: mail }}>
                    {/* <div className="card-title" style={{ width: '100%' }}>
                        <h3>{t('SEND VIA')}</h3>
                    </div> */}
                    {/* <div style={{ display: 'flex', flexDirection: 'row' }}> */}
                    {/* <Form.Item name="email" valuePropName="checked" initialValue={true}>
                            <Radio>{t('Email')}</Radio>
                        </Form.Item> */}
                    {/* <Form.Item name="whatsapp" valuePropName="checked" initialValue={false}>
                            <Radio>Whatsapp</Radio>
                        </Form.Item> */}
                    {/* </div> */}
                    {/* <Form.Item
                        name="email"
                        // rules={[
                        //     { required: true, message: 'Please enter your email!' },
                        //     { type: 'email', message: 'Please enter a valid email address!' },
                        // ]}
                    >
                        {props.isEmailEditable ? (
                            <Input type="email" value={mail} onChange={(e) => setEditedEmail(e.target.value)} style={{ width: '640px' }} />
                        ) : (
                            <Input type="email" value={mail} readOnly style={{ width: '640px' }} />
                        )}
                    </Form.Item> */}
                    {/* / commented for future WhatsApp development   */}
                    {/* <Form.Item
                       
                        rules={[
                            { required: true, message: 'Enter whatsapp number!' },
                            { type: 'email', message: 'Please enter a valid number!' },
                        ]}
                    >
                        <Input placeholder="Enter Whatsapp Number" />
                    </Form.Item> */}
                    {/* === SEND VIA HEADER === */}
                    <div className="send-via-header">
                        <h3 style={{ marginRight: '30px' }}>{t('Send Via')}</h3>

                        <div className="send-via-checkboxes">
                            {/* <Checkbox checked={sendVia.email} onChange={handleEmailCheckboxChange}> */}
                            {/* {t('Email ID')} */}
                            {/* </Checkbox> */}
                            {/* / commented for future WhatsApp development   */}
                            {/* <Checkbox checked={sendVia.whatsapp} onChange={(e) => setSendVia({ ...sendVia, whatsapp: e.target.checked })}>
                                {t('WhatsApp')}
                            </Checkbox> */}
                        </div>
                    </div>

                    {/* === SHOW ONLY IF ANY CHECKED === */}
                    {(sendVia.email || sendVia.whatsapp) && (
                        <>
                            {/* === GUEST SECTION === */}
                            <h4 className="section-title">{t('Guest')}</h4>

                            <div className="guest-section">
                                {sendVia.email && (
                                    <div className="guest-item">
                                        <Checkbox checked={sendVia.email} onChange={handleEmailCheckboxChange} />
                                        <span className="guest-label">{mail || t('No email available')}</span>
                                        <MailOutlined className="guest-icon email-icon" />
                                    </div>
                                )}
                                {/* / commented for future WhatsApp development   */}
                                {/* {sendVia.whatsapp && (
                                    <div className="guest-item">
                                        <Checkbox
                                            checked={sendVia.whatsapp}
                                            onChange={(e) =>
                                                setSendVia({
                                                    ...sendVia,
                                                    whatsapp: e.target.checked,
                                                })
                                            }
                                        />
                                        <span className="guest-label">{mobileNo || t('+91-9876543210')}</span>
                                        <WhatsAppOutlined className="guest-icon whatsapp-icon" />
                                    </div>
                                )} */}
                            </div>

                            {/* === CORPORATE SECTION === */}
                            {corporateEmail && (
                                <div className="corporate-section">
                                    <div>
                                        {t(
                                            'This Corporate guest has Report Sharing enabled to the Corporate . Please upload the Guest Consent to have the reports shared to the Corporate .'
                                        )}
                                    </div>
                                    <h4 className="section-title">{t('Corporate')}</h4>

                                    <div className="corporate-checkboxes">
                                        <Checkbox
                                            checked={sendVia.corporate}
                                            onChange={(e) => setSendVia({ ...sendVia, corporate: e.target.checked })}
                                        >
                                            {corporateEmail}
                                            <MailOutlined className="corporate-icon" />
                                        </Checkbox>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    <Form.Item>
                        <Space style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                            <Button htmlType="button" onClick={callback} type="Secondary">
                                {t('Cancel')}
                            </Button>
                            <Button type="primary" htmlType="submit" loading={isLoading} disabled={disable}>
                                {t('Send Report')}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
